/**
 * Gemeentepagina's Zuid-Holland: overkoepelende hub per gemeente met links
 * naar alle woonplaatsen waar wij taxivervoer met vaste prijs verzorgen.
 */

export type LocalGemeente = {
  slug: string;
  name: string;
  url: string;
  province: "Zuid-Holland";
  /** Slugs van woonplaatsen binnen deze gemeente. */
  places: string[];
};

export const GEMEENTEN: LocalGemeente[] = [
  {
    slug: "alblasserdam",
    name: "Alblasserdam",
    url: "https://www.alblasserdam.nl",
    province: "Zuid-Holland",
    places: ["alblasserdam"],
  },
  {
    slug: "albrandswaard",
    name: "Albrandswaard",
    url: "https://www.albrandswaard.nl",
    province: "Zuid-Holland",
    places: ["poortugaal", "rhoon", "rotterdam-albrandswaard"],
  },
  {
    slug: "alphen-aan-den-rijn",
    name: "Alphen aan den Rijn",
    url: "https://www.alphenaandenrijn.nl",
    province: "Zuid-Holland",
    places: ["aarlanderveen", "alphen-aan-den-rijn", "benthuizen", "boskoop", "hazerswoude-dorp", "hazerswoude-rijndijk", "koudekerk-aan-den-rijn", "zwammerdam"],
  },
  {
    slug: "barendrecht",
    name: "Barendrecht",
    url: "https://www.barendrecht.nl",
    province: "Zuid-Holland",
    places: ["barendrecht"],
  },
  {
    slug: "bodegraven-reeuwijk",
    name: "Bodegraven-Reeuwijk",
    url: "https://www.bodegraven-reeuwijk.nl",
    province: "Zuid-Holland",
    places: ["bodegraven", "driebruggen", "nieuwerbrug-aan-den-rijn", "reeuwijk", "waarder"],
  },
  {
    slug: "capelle-aan-den-ijssel",
    name: "Capelle aan den IJssel",
    url: "https://www.capelleaandenijssel.nl",
    province: "Zuid-Holland",
    places: ["capelle-aan-den-ijssel"],
  },
  {
    slug: "delft",
    name: "Delft",
    url: "https://www.delft.nl",
    province: "Zuid-Holland",
    places: ["delft"],
  },
  {
    slug: "dordrecht",
    name: "Dordrecht",
    url: "https://www.dordrecht.nl",
    province: "Zuid-Holland",
    places: ["dordrecht"],
  },
  {
    slug: "goeree-overflakkee",
    name: "Goeree-Overflakkee",
    url: "https://www.goeree-overflakkee.nl",
    province: "Zuid-Holland",
    places: ["achthuizen", "den-bommel", "dirksland", "goedereede", "herkingen", "melissant", "middelharnis", "nieuwe-tonge", "ooltgensplaat", "ouddorp", "oude-tonge", "sommelsdijk", "stad-aan-t-haringvliet", "stellendam"],
  },
  {
    slug: "gorinchem",
    name: "Gorinchem",
    url: "https://www.gorinchem.nl",
    province: "Zuid-Holland",
    places: ["dalem", "gorinchem"],
  },
  {
    slug: "gouda",
    name: "Gouda",
    url: "https://www.gouda.nl",
    province: "Zuid-Holland",
    places: ["gouda"],
  },
  {
    slug: "hardinxveld-giessendam",
    name: "Hardinxveld-Giessendam",
    url: "https://www.hardinxveld-giessendam.nl",
    province: "Zuid-Holland",
    places: ["hardinxveld-giessendam"],
  },
  {
    slug: "hendrik-ido-ambacht",
    name: "Hendrik-Ido-Ambacht",
    url: "https://www.h-i-ambacht.nl",
    province: "Zuid-Holland",
    places: ["hendrik-ido-ambacht"],
  },
  {
    slug: "hillegom",
    name: "Hillegom",
    url: "https://www.hillegom.nl",
    province: "Zuid-Holland",
    places: ["hillegom"],
  },
  {
    slug: "hoeksche-waard",
    name: "Hoeksche Waard",
    url: "https://www.hoekschewaard.nl",
    province: "Zuid-Holland",
    places: ["s-gravendeel", "goudswaard", "heinenoord", "klaaswaal", "maasdam", "mijnsheerenland", "mookhoek", "nieuw-beijerland", "numansdorp", "oud-beijerland", "piershil", "puttershoek", "strijen", "strijensas", "westmaas", "zuid-beijerland"],
  },
  {
    slug: "kaag-en-braassem",
    name: "Kaag en Braassem",
    url: "https://www.kaagenbraassem.nl",
    province: "Zuid-Holland",
    places: ["hoogmade", "kaag", "leimuiden", "nieuwe-wetering", "oud-ade", "oude-wetering", "rijnsaterwoude", "rijpwetering", "roelofarendsveen", "woubrugge"],
  },
  {
    slug: "katwijk",
    name: "Katwijk",
    url: "https://www.katwijk.nl",
    province: "Zuid-Holland",
    places: ["katwijk", "rijnsburg", "valkenburg"],
  },
  {
    slug: "krimpen-aan-den-ijssel",
    name: "Krimpen aan den IJssel",
    url: "https://www.krimpenaandenijssel.nl",
    province: "Zuid-Holland",
    places: ["krimpen-aan-den-ijssel"],
  },
  {
    slug: "krimpenerwaard",
    name: "Krimpenerwaard",
    url: "https://www.krimpenerwaard.nl",
    province: "Zuid-Holland",
    places: ["ammerstol", "bergambacht", "berkenwoude", "gouderak", "haastrecht", "krimpen-aan-de-lek", "lekkerkerk", "ouderkerk-aan-den-ijssel", "schoonhoven", "stolwijk", "vlist"],
  },
  {
    slug: "lansingerland",
    name: "Lansingerland",
    url: "https://www.lansingerland.nl",
    province: "Zuid-Holland",
    places: ["bergschenhoek", "berkel-en-rodenrijs", "bleiswijk"],
  },
  {
    slug: "leiden",
    name: "Leiden",
    url: "https://www.leiden.nl",
    province: "Zuid-Holland",
    places: ["leiden"],
  },
  {
    slug: "leiderdorp",
    name: "Leiderdorp",
    url: "https://www.leiderdorp.nl",
    province: "Zuid-Holland",
    places: ["leiderdorp"],
  },
  {
    slug: "leidschendam-voorburg",
    name: "Leidschendam-Voorburg",
    url: "https://www.lv.nl",
    province: "Zuid-Holland",
    places: ["leidschendam", "voorburg"],
  },
  {
    slug: "lisse",
    name: "Lisse",
    url: "https://www.lisse.nl",
    province: "Zuid-Holland",
    places: ["lisse"],
  },
  {
    slug: "maassluis",
    name: "Maassluis",
    url: "https://www.maassluis.nl",
    province: "Zuid-Holland",
    places: ["maassluis"],
  },
  {
    slug: "midden-delfland",
    name: "Midden-Delfland",
    url: "https://www.middendelfland.nl",
    province: "Zuid-Holland",
    places: ["den-hoorn", "maasland", "schipluiden"],
  },
  {
    slug: "molenlanden",
    name: "Molenlanden",
    url: "https://www.molenlanden.nl",
    province: "Zuid-Holland",
    places: ["arkel", "bleskensgraaf-ca", "brandwijk", "giessenburg", "goudriaan", "groot-ammers", "hoogblokland", "hoornaar", "kinderdijk", "langerak", "molenaarsgraaf", "nieuw-lekkerland", "nieuwpoort", "noordeloos", "ottoland", "oud-alblas", "schelluinen", "streefkerk", "waal", "wijngaarden"],
  },
  {
    slug: "nieuwkoop",
    name: "Nieuwkoop",
    url: "https://www.nieuwkoop.nl",
    province: "Zuid-Holland",
    places: ["nieuwkoop", "nieuwveen", "noorden", "ter-aar", "vrouwenakker", "woerdense-verlaat", "zevenhoven"],
  },
  {
    slug: "nissewaard",
    name: "Nissewaard",
    url: "https://www.nissewaard.nl",
    province: "Zuid-Holland",
    places: ["abbenbroek", "geervliet", "heenvliet", "hekelingen", "simonshaven", "spijkenisse", "zuidland"],
  },
  {
    slug: "noordwijk",
    name: "Noordwijk",
    url: "https://www.noordwijk.nl",
    province: "Zuid-Holland",
    places: ["de-zilk", "noordwijk", "noordwijkerhout"],
  },
  {
    slug: "oegstgeest",
    name: "Oegstgeest",
    url: "https://www.oegstgeest.nl",
    province: "Zuid-Holland",
    places: ["oegstgeest"],
  },
  {
    slug: "papendrecht",
    name: "Papendrecht",
    url: "https://www.papendrecht.nl",
    province: "Zuid-Holland",
    places: ["papendrecht"],
  },
  {
    slug: "pijnacker-nootdorp",
    name: "Pijnacker-Nootdorp",
    url: "https://www.pijnacker-nootdorp.nl",
    province: "Zuid-Holland",
    places: ["delfgauw", "nootdorp", "pijnacker"],
  },
  {
    slug: "ridderkerk",
    name: "Ridderkerk",
    url: "https://www.ridderkerk.nl",
    province: "Zuid-Holland",
    places: ["ridderkerk"],
  },
  {
    slug: "rijswijk",
    name: "Rijswijk",
    url: "https://www.rijswijk.nl",
    province: "Zuid-Holland",
    places: ["rijswijk"],
  },
  {
    slug: "rotterdam",
    name: "Rotterdam",
    url: "https://www.rotterdam.nl",
    province: "Zuid-Holland",
    places: ["hoek-van-holland", "hoogvliet-rotterdam", "pernis-rotterdam", "rotterdam", "rozenburg"],
  },
  {
    slug: "schiedam",
    name: "Schiedam",
    url: "https://www.schiedam.nl",
    province: "Zuid-Holland",
    places: ["schiedam"],
  },
  {
    slug: "sliedrecht",
    name: "Sliedrecht",
    url: "https://www.sliedrecht.nl",
    province: "Zuid-Holland",
    places: ["sliedrecht"],
  },
  {
    slug: "teylingen",
    name: "Teylingen",
    url: "https://www.teylingen.nl",
    province: "Zuid-Holland",
    places: ["sassenheim", "voorhout", "warmond"],
  },
  {
    slug: "vlaardingen",
    name: "Vlaardingen",
    url: "https://www.vlaardingen.nl",
    province: "Zuid-Holland",
    places: ["vlaardingen"],
  },
  {
    slug: "voorne-aan-zee",
    name: "Voorne aan Zee",
    url: "https://www.voorneaanzee.nl",
    province: "Zuid-Holland",
    places: ["brielle", "hellevoetsluis", "oostvoorne", "oudenhoorn", "rockanje", "tinte", "vierpolders", "zwartewaal"],
  },
  {
    slug: "voorschoten",
    name: "Voorschoten",
    url: "https://www.voorschoten.nl",
    province: "Zuid-Holland",
    places: ["voorschoten"],
  },
  {
    slug: "waddinxveen",
    name: "Waddinxveen",
    url: "https://www.waddinxveen.nl",
    province: "Zuid-Holland",
    places: ["waddinxveen"],
  },
  {
    slug: "wassenaar",
    name: "Wassenaar",
    url: "https://www.wassenaar.nl",
    province: "Zuid-Holland",
    places: ["wassenaar"],
  },
  {
    slug: "westland",
    name: "Westland",
    url: "https://www.westland.nl",
    province: "Zuid-Holland",
    places: ["s-gravenzande", "de-lier", "honselersdijk", "kwintsheul", "maasdijk", "monster", "naaldwijk", "poeldijk", "ter-heijde", "wateringen"],
  },
  {
    slug: "zoetermeer",
    name: "Zoetermeer",
    url: "https://www.zoetermeer.nl",
    province: "Zuid-Holland",
    places: ["zoetermeer"],
  },
  {
    slug: "zoeterwoude",
    name: "Zoeterwoude",
    url: "https://www.zoeterwoude.nl",
    province: "Zuid-Holland",
    places: ["gelderswoude", "zoeterwoude"],
  },
  {
    slug: "zuidplas",
    name: "Zuidplas",
    url: "https://www.zuidplas.nl",
    province: "Zuid-Holland",
    places: ["cortelande", "moerkapelle", "moordrecht", "nieuwerkerk-aan-den-ijssel", "zevenhuizen"],
  },
  {
    slug: "zwijndrecht",
    name: "Zwijndrecht",
    url: "https://www.zwijndrecht.nl",
    province: "Zuid-Holland",
    places: ["heerjansdam", "zwijndrecht"],
  },
];

export const GEMEENTEN_BY_SLUG = new Map(GEMEENTEN.map((g) => [g.slug, g]));
